import pages from "../../constants/pages.js";
import GateEntryRequest from "../../pages/Gate Entry Request Components/GateEntryRequest.js";
import VisitorSignUp from "../../pages/visitor sign up components/VisitorSignUp.js";
import async from "./Async";

// Lazily loaded pages for better code-splitting
const Success = async(() => import("../../pages/Success/"));
const Form = async(() => import("../../pages/sign in components/Form.js"));
const HomeComponent = async(() => import("../../pages/home components/Home"));
const Liveliness = async(() => import("../../pages/Liveliness/CaptureVideo"));
const VideoLiveliness = async(() =>
  import("../../pages/Video Liveliness/CaptureVideo.js")
);
const SignUp = async(() => import("../../pages/sign up components/SignUp.js"));
const AppointmentErrorPage = async(() => import("../../pages/Error/index.js"));
const ContactUs = async(() => import("../../pages/home components/Contact.js"));
const previewVideo = async(() => import("../../pages/Liveliness/PreviewVideo"));

const previewLivelinessVideo = async(() =>
  import("../../pages/Video Liveliness/PreviewVideo.js")
);

const Profile = async(() =>
  import("../../pages/Profile components/Profile.js")
);
const Transaction = async(() => import("../../pages/Transaction/Transaction"));
const Consent = async(() =>
  import("../../pages/Consent components/Consent.js")
);
const Verification = async(() =>
  import("../../pages/Verification/Verificaion")
);
const HotelBooking = async(() =>
  import("../../pages/Hotel components/Hotel.js")
);
const CheckIn = async(() =>
  import("../../pages/Check In Components/CheckIn.js")
);
const appointment = async(() =>
  import("../../pages/appointment components/Home")
);
const EventList = async(() =>
  import("../../pages/Event Components/EventList.js")
);
const Demo = async(() =>
  import("../../pages/Invite User components/InviteUser.js")
);
const ShopsMore = async(() =>
  import("../../pages/Shops More components/ShopsMore.js")
);
const UploadDocument = async(() =>
  import("../../pages/UploadDocument/UploadDocument")
);
const TrackAppointment = async(() =>
  import("../../pages/Track Appointment/index.js")
);
const EventBooking = async(() =>
  import("../../pages/Booking/EventBooking/EventBooking")
);
const InviteUser = async(() =>
  import("../../pages/Invite User components/InviteUser.js")
);
const CampusUser = async(() =>
  import("../../pages/Campus User Components/CampusUser.js")
);
const ShopView = async(() =>
  import("../../pages/Shops More components/Shops/ShopView.js")
);
const ManualEntry = async(() =>
  import("../../pages/Manual Entry Components/ManualEntry.js")
);
const AddHotelBooking = async(() =>
  import("../../pages/Hotel components/AddHotelBooking.js")
);
const HotelView = async(() =>
  import("../../pages/Shops More components/Hotels/HotelView.js")
);
const ShopListView = async(() =>
  import("../../pages/Shops More components/Shops/ListView.js")
);
const HotelSummary = async(() =>
  import("../../pages/Hotel Summary Components/HotelSummary.js")
);
const EventSummary = async(() =>
  import("../../pages/Event Summary Components/EventSummary.js")
);
const EntrySummary = async(() =>
  import("../../pages/Entry Summary Components/EntrySummary.js")
);
const BoardingPass = async(() =>
  import("../../pages/Boarding Pass components/BoardingPass.js")
);
const BookingStats = async(() =>
  import("../../pages/Booking Stats Components/BookingStats.js")
);
const AutoGateOpen = async(() =>
  import("../../pages/Auto Gate Open Components/AutoGateOpen.js")
);
const BioVerificaion = async(() =>
  import("../../pages/Booking/BioVerification/BioVerificaion")
);
const CampusSummary = async(() =>
  import("../../pages/Campus Summary Components/CampusSummary.js")
);
const EventDetail = async(() =>
  import("../../pages/Event Components/Event Details/EventDetail.js")
);
const AddBooking = async(() =>
  import("../../pages/Add Booking Components/AddBooking/AddBooking.js")
);
const HotelListView = async(() =>
  import("../../pages/Shops More components/Hotels/HotelListView.js")
);
const EventBookingDetails = async(() =>
  import("../../pages/Booking/EventBooking/EventBookingDetails")
);
const OutingPassPage = async(() =>
  import("../../pages/Outing Pass Page components/OutingPassPage.js")
);
// const MeetingRoomList = async(
//   () => import("../../pages/meeting room components/MeetingRoomList.js")
// );
const AppointmentBooking = async(() =>
  import("../../pages/Booking/AppointmentBooking/AppointmentBooking")
);
const OutingPassListPage = async(() =>
  import("../../pages/Outing Pass Page components/OutingPassListPage.js")
);
const AppointmentSummary = async(() =>
  import("../../pages/Appointment Summary Components/AppointmentSummary.js")
);
const ManualVerification = async(() =>
  import("../../pages/Manual Verification Components/ManualVerification.js")
);
const ResendNotification = async(() =>
  import("../../pages/Resend Notification Components/ResendNotification.js")
);
const DrivingLicenceDetails = async(() =>
  import("../../pages/Verification/DrivingLicence/DrivingLicenceDetails")
);
const AppointmentBookingDetails = async(() =>
  import("../../pages/Booking/AppointmentBooking/AppointmentBookingDetails")
);
const AadharverificaionDetails = async(() =>
  import("../../pages/Verification/Aadharverificaion/AadharverificaionDetails")
);
const AadharverificaionSuccess = async(() =>
  import(
    "../../pages/Verification/Aadharverificaion/AadharverificaionSuccess.js"
  )
);
const MainGateEntryWithBackCamera = async(() =>
  import(
    "../../pages/MainGate Entry With Back Camera  Components/MainGateEntry.js"
  )
);
const MainGateEntryWithFrontCamera = async(() =>
  import(
    "../../pages/MainGate Entry With Front Camera  Components/MainGateEntry.js"
  )
);
const IndependentAppointment = async(() =>
  import(
    "../../pages/Booking/IndependentAppointmentBooking/IndependentAppointmentBooking.js"
  )
);
const IndependentAppointmentSummary = async(() =>
  import(
    "../../pages/Independent Appointment Summary Components/IndependentAppointmentSummary.js"
  )
);
const EventConsent = async(() =>
  import("../../pages/Consent components/EventConsent.js")
);
const EventSuccess = async(() => import("../../pages/Success/EventSuccess.js"));
const StudentProfile = async(() =>
  import("../../pages/Student Profile components/StudentProfile.js")
);
// const WardenFlow = async(
//   () => import("../../pages/Student Entry Components/Warden Flow/WardenFlow.js")
// );
const GuardFlow = async(() =>
  import("../../pages/Student Entry Components/Guard Flow/GuardFlow.js")
);
const GuardUserDetails = async(() =>
  import("../../pages/Guard User Details/GuardUserDetails.js")
);
const ErrorPage500 = async(() => import("../../pages/Error/ErrorPage500.js"));
const GuardianProfile = async(() =>
  import("../../pages/Appointment Request Components/AppointmentRequest.js")
);
const AppointmentRequest = async(() =>
  import("../../pages/Appointment Request Components/AppointmentRequest.js")
);
const GuardianRequest = async(() =>
  import("../../pages/Guardian Request Components/GuardianRequest.js")
);

const ScanQR = async(() => import("../../pages/ScanQR/ScanQR.js"));

const DocVerification = async(() =>
  import("../../pages/OCR Verification/OCRVerificaion.js")
);

const PhotoVerification = async(() =>
  import("../../pages/OCR Liveliness/OCRCaptureVideo.js")
);

const GuestVerification = async(() =>
  import("../../pages/Guest Verification/GuestVerification.js")
);

const Settings = async(() => import("../../pages/Settings/Settings.js"));

const Dependents = async(() => import("../../pages/Settings/Dependents.js"));

const EmployeeDetails = async(() =>
  import("../../pages/Employee Details Components/EmployeeDetails.js")
);

const Guardians = async(() => import("../../pages/Settings/Guardians.js"));

const Parking = async(() => import("../../pages/Settings/Parking.js"));

const applicationLayoutRoutes = {
  homePageRoute: {
    ID: "Home",
    path: pages.home.route,
    element: HomeComponent,
  },

  eventListPageRoute: {
    ID: "EventList",
    path: pages.eventListPage.route,
    element: EventList,
  },

  appointmentPageRoute: {
    ID: "appointment",
    path: pages.appointment.route,
    element: appointment,
  },

  ContactUs: {
    ID: "ContactUs",
    path: pages.ContactUs.route,
    element: ContactUs,
  },

  signInRoute: {
    ID: "sign-in",
    path: pages.SignIn.route,
    element: Form,
  },

  signOutRoute: {
    ID: "sign-up",
    path: pages.SignUp.route,
    element: SignUp,
  },

  TrackAppointmentPageRoute: {
    ID: "TrackAppointment",
    path: pages.TrackAppointment.route,
    element: TrackAppointment,
  },

  previewVideoPageRoute: {
    ID: "previewVideo",
    path: pages.previewVideo.route,
    element: previewVideo,
  },

  livelinessPageRoute: {
    ID: "liveliness",
    path: pages.checkLiveliness.route,
    element: Liveliness,
  },

  Success: {
    ID: "Success",
    path: pages.Success.route,
    element: Success,
  },

  AadharverificaionSuccess: {
    ID: "AadharverificaionSuccess",
    path: pages.AadharverificaionSuccess.route,
    element: AadharverificaionSuccess,
  },

  Error: {
    ID: "Error",
    path: pages.Error.route,
    element: AppointmentErrorPage,
  },

  Verification: {
    ID: "Verification",
    path: pages.Verification.route,
    element: Verification,
  },

  CampusVerification: {
    ID: "CampusVerification",
    path: pages.CampusVerification.route,
    element: Verification,
  },

  AppointmentVerification: {
    ID: "AppointmentVerification",
    path: pages.AppointmentVerification.route,
    element: Verification,
  },

  HotelVerification: {
    ID: "HotelVerification",
    path: pages.HotelVerification.route,
    element: Verification,
  },

  UploadDocument: {
    ID: "UploadDocument",
    path: pages.UploadDocument.route,
    element: UploadDocument,
  },

  EventBooking: {
    ID: "EventBooking",
    path: pages.EventBooking.route + "/" + ":eventID" + "/" + ":id",
    element: EventBooking,
  },

  DocVerification: {
    ID: "DocVerification",
    path: pages.DocVerification.route,
    element: DocVerification,
  },

  PhotoVerification: {
    ID: "PhotoVerification",
    path: pages.PhotoVerification.route,
    element: PhotoVerification,
  },

  EventBookingDetails: {
    ID: "EventBookingDetails",
    path: pages.EventBookingDetails.route,
    element: EventBookingDetails,
  },

  AppointmentBooking: {
    ID: "AppointmentBooking",
    path: pages.AppointmentBooking.route,
    element: AppointmentBooking,
  },

  IndependentAppointment: {
    ID: "IndependentAppointmentBooking",
    path: pages.IndependentAppointmentBooking.route,
    element: IndependentAppointment,
  },

  AppointmentBookingDetails: {
    ID: "AppointmentBookingDetails",
    path: pages.AppointmentBookingDetail.route,
    element: AppointmentBookingDetails,
  },

  AadharverificaionDetails: {
    ID: "AadharverificaionDetails",
    path: pages.AadharverificaionDetails.route,
    element: AadharverificaionDetails,
  },

  DrivingLicenceDetails: {
    ID: "DrivingLicenceDetails",
    path: pages.DrivingLicenceDetails.route,
    element: DrivingLicenceDetails,
  },
  BioVerificaion: {
    ID: "BioVerificaion",
    path: pages.BioVerificaion.route,
    element: BioVerificaion,
  },

  MainGateEntryWithBackCamera: {
    ID: "MainGateEntryWithBackCamera",
    path: pages.MainGateEntryWithBackCamera.route,
    element: MainGateEntryWithBackCamera,
  },

  MainGateEntryWithFrontCamera: {
    ID: "MainGateEntryWithFrontCamera",
    path: pages.MainGateEntryWithFrontCamera.route,
    element: MainGateEntryWithFrontCamera,
  },

  ManualEntry: {
    ID: "ManualEntry",
    path: pages.ManualEntry.route,
    element: ManualEntry,
  },

  ManualVerification: {
    ID: "ManualVerification",
    path: pages.ManualVerification.route,
    element: ManualVerification,
  },

  ResendNotification: {
    ID: "ResendNotification",
    path: pages.ResendNotification.route,
    element: ResendNotification,
  },

  Consent: {
    ID: "Consent",
    path: pages.Consent.route,
    element: EventConsent,
  },

  AppointmentConsent: {
    ID: "AppointmentConsent",
    path: pages.AppointmentConsent.route,
    element: Consent,
  },

  BoardingPass: {
    ID: "BoardingPass",
    path: pages.BoardingPass.route,
    element: BoardingPass,
  },

  ShopsMore: {
    ID: "ShopsMore",
    path: pages.ShopsMore.route,
    element: ShopsMore,
  },

  Shops: {
    ID: "Shops",
    path: pages.Shops.route,
    element: ShopListView,
  },

  Hotels: {
    ID: "Hotels",
    path: pages.Hotels.route,
    element: HotelListView,
  },

  Shop: {
    ID: "Shops",
    path: pages.Shop.route,
    element: ShopView,
  },

  Hotel: {
    ID: "Hotel",
    path: pages.Hotel.route,
    element: HotelView,
  },

  Transaction: {
    ID: "Transaction",
    path: pages.Transaction.route,
    element: Transaction,
  },

  Profile: {
    ID: "Profile",
    path: pages.Profile.route,
    element: Profile,
  },

  eventListPageRoute: {
    ID: "EventList",
    path: pages.eventListPage.route,
    element: EventList,
  },

  eventPageRoute: {
    ID: "Event",
    path: pages.EventPage.path,
    element: EventDetail,
  },

  HotelBookingPageRoute: {
    ID: "HotelBookingPageRoute",
    path: pages.HotelBookingPage.route,
    element: HotelBooking,
  },

  AddHotelBookingPageRoute: {
    ID: "AddHotelBookingPageRoute",
    path: pages.AddHotelBookingPage.path,
    element: AddHotelBooking,
  },

  eventInviteUserPageRoute: {
    ID: "eventInviteUserPageRoute",
    path: pages.eventInviteUserPage.path,
    element: InviteUser,
  },

  appointmentInviteUserPageRoute: {
    ID: "appointmentInviteUserPageRoute",
    path: pages.appointmentInviteUserPage.path,
    element: InviteUser,
  },

  hotelInviteUserPageRoute: {
    ID: "hotelInviteUserPageRoute",
    path: pages.InviteUserPage.path,
    element: InviteUser,
  },

  HotelConsent: {
    ID: "HotelConsent",
    path: pages.HotelConsent.route,
    element: Consent,
  },

  OutingPage: {
    ID: "OutingPage",
    path: pages.OutingPage.route,
    element: OutingPassPage,
  },

  OutingPassListPage: {
    ID: "OutingPassListPage",
    path: pages.OutingPassListPage.route,
    element: OutingPassListPage,
  },

  CampusUserPage: {
    ID: "CampusUserPage",
    path: pages.CampusUserPage.route,
    element: CampusUser,
  },

  CheckInPage: {
    ID: "CheckInPage",
    path: pages.CheckInPage.route,
    element: CheckIn,
  },

  EventSummary: {
    ID: "EventSummary",
    path: pages.EventSummary.route,
    element: EventSummary,
  },

  AppointmentSummary: {
    ID: "AppointmentSummary",
    path: pages.AppointmentSummary.route,
    element: AppointmentSummary,
  },

  IndependentAppointmentSummary: {
    ID: "IndependentAppointmentSummary",
    path: pages.IndependentAppointmentSummary.route,
    element: IndependentAppointmentSummary,
  },

  CampusSummary: {
    ID: "CampusSummary",
    path: pages.CampusSummary.route,
    element: CampusSummary,
  },

  HotelSummary: {
    ID: "HotelSummary",
    path: pages.HotelSummary.path,
    element: HotelSummary,
  },

  EntrySummary: {
    ID: "EntrySummary",
    path: pages.EntrySummary.route,
    element: EntrySummary,
  },

  AutoGateOpenPage: {
    ID: "AutoGateOpenPage",
    path: pages.AutoGateOpen.route,
    element: AutoGateOpen,
  },

  AddBookingPage: {
    ID: "AddBookingPage",
    path: pages.AddBooking.route,
    element: AddBooking,
  },

  BookingStatsPage: {
    ID: "BookingStatsPage",
    path: pages.BookingStats.route,
    element: BookingStats,
  },

  EventSuccessPage: {
    ID: "EventSuccessPage",
    path: pages.EventSuccess.route,
    element: EventSuccess,
  },

  StudentProfilePage: {
    ID: "StudentProfilePage",
    path: pages.studentProfile.route,
    element: StudentProfile,
  },

  AppointmentRequestPage: {
    ID: "AppointmentRequestPage",
    path: pages.appointmentRequest.route,
    element: AppointmentRequest,
  },

  GuardianRequestPage: {
    ID: "GuardianRequestPage",
    path: pages.guardianRequest.route,
    element: GuardianRequest,
  },

  videoLivelinessPageRoute: {
    ID: "liveliness",
    path: pages.videoLiveliness.route,
    element: VideoLiveliness,
  },

  previewLivelinessVideoPageRoute: {
    ID: "previewLivelinessVideo",
    path: "/preview-liveliness-video",
    element: previewLivelinessVideo,
  },

  // wardenFlowPageRoute: {
  //   ID: "WardenFlowPageRoute",
  //   path: pages.WardenFlow.route,
  //   element: WardenFlow,
  // },

  guardFlowPageRoute: {
    ID: "GuardFlowPageRoute",
    path: "/guard-flow",
    element: GuardFlow,
  },

  guardUserDetailsRoute: {
    ID: "GuardUserDetailsRoute",
    path: pages.GuardUserDetails.route,
    element: GuardUserDetails,
  },

  Error500: {
    ID: "Error500",
    path: pages.Error500.route,
    element: ErrorPage500,
  },

  ScanQR: {
    ID: "ScanQR",
    path: pages.ScanQR.route,
    element: ScanQR,
  },
  GuestVerification: {
    ID: "GuestVerification",
    path: pages.GuestVerification.route,
    element: GuestVerification,
  },

  SettingsPage: {
    ID: "SettingsPage",
    path: pages.SettingsPage.route,
    element: Settings,
  },

  DependentsPage: {
    ID: "DependentsPage",
    path: pages.DependentsPage.route,
    element: Dependents,
  },

  EmployeeDetailsPage: {
    ID: "EmployeeDetailsPage",
    path: pages.EmployeeDetailsPage.route,
    element: EmployeeDetails,
  },

  GuardiansPage: {
    ID: "GuardiansPage",
    path: pages.GuardiansPage.route,
    element: Guardians,
  },

  ParkingPage: {
    ID: "ParkingPage",
    path: pages.ParkingPage.route,
    element: Parking,
  },
  visitorSignUpRoute: {
    ID: "visitor-sign-up",
    path: pages.VisitorSignUp.route,
    element: VisitorSignUp,
  },

  gateEntryRequestRoute: {
    ID: "gate-entry-request",
    path: pages.gateEntryRequest.route,
    element: GateEntryRequest,
  },
};

export default applicationLayoutRoutes;
// gateEntryRequest
